export default __webpack_public_path__ + "static/media/Mobile.c8f44285.png";